// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5e438908","453":"3f8e2095"}[chunkId] + ".chunk.js";
};